export default "__VITE_ASSET__wAInS8oV__"